import { useEffect } from "react";

const SITE = "BRaIN — Bengaluru Research and Innovation Network";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | BRaIN` : SITE;
    const tag = document.querySelector('meta[name="description"]');
    if (tag && description) tag.setAttribute("content", description);
  }, [title, description]);
}
